import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrl: './upload-image.component.css',
  standalone: false
})
export class UploadImageComponent extends AppComponentBase
  implements OnInit {
  _imageUrl: string | ArrayBuffer | null = "/assets/img/avatar-logo.png";

  @Input() set imageUrl(v: string | ArrayBuffer | null) {
    if (v) {
      this._imageUrl = v
    }
  };
  @Output() onSelectedImage = new EventEmitter<File>();
  @Input() isDisabled: boolean = false;
  constructor(
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {

  }

  onSelectImage(event: any) {
    let selectedFile = event.target.files[0];
    if (selectedFile) {

      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed

        this._imageUrl = (<FileReader>event.target).result;
        this.onSelectedImage.emit(selectedFile);
      }
    }
  }

  
  resetImage($event: any) {
    $event.target.value = '';
  }

}
